import { single_mosfet } from './single_mosfet';
import { SINGLE_MOSFET } from '../../constants/prtParametersNames';
import { ID_GRAPH_AXIS } from '../../constants/idDefinition';
import { CHART_TYPE, SIMULATION_TYPE, UNITS_SIGN } from '../../constants/definitionConstants';

export class nvhl080n120sc1a extends single_mosfet {
	constructor(opn) {
		super(opn, 'nvhl080n120sc1a');
		this.PACKAGE_IMAGE = require(`../../images/TO247_3LD_CASE_340CX.png`);
		this.modelLink = `https://www.${this.domain}/download/models/zip/onsemi_sicmosfet_1200_pspice.zip`;
		this.netlistPath = `resources/${this.wpn}/${this.opn}/netlists/${this.opn}_3P_DC.txt`;
		this.netlistTempSweep = `resources/${this.wpn}/${this.opn}/netlists/${this.opn}_Temp_DC.txt`;
		this.SCHEMATICTempSweep = require(`../../images/${this.opn}_TEMP_SCH.svg`);
	}

	gainDefinition() {
		const TEMP_SWEEP_CHART_COLUMN_MAPPING = {
			TEMP: 0,
			V_GS: 1,
			V_DS: 2,
			I_DRAIN: 3,
			R_DSON: 4
		};
		const customizations = {
			simulations: [
				{
					inputParameters: [
						{
							/**
							 * base heading (heading is created from heading + unit)
							 */
							heading: 'V<sub>GS<sub>(min)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							/**
							 * if unit is not base unit but for example it is in kilo ohm it is needed
							 * to add extension for simulator which tells that it is kilo that’s mean ‘k’
							 */
							netlistUnit: '',
							/**
							 * exact name of parameter from netlist to be replaced
							 */
							mappingName: 'VgsMin',
							minBoundary: 2,
							maxBoundary: 15,
							defaultValue: 6
						},
						{
							heading: 'V<sub>GS<sub>(max)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'VgsMax',
							minBoundary: 2.5,
							maxBoundary: 20,
							defaultValue: 15
						},
						{
							heading: 'V<sub>GS<sub>(increment)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'VgsStep',
							minBoundary: 0.5,
							maxBoundary: 5,
							defaultValue: 1
						},
						{
							heading: 'V<sub>D<sub>(min)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'VdMin',
							minBoundary: 1,
							maxBoundary: 29,
							defaultValue: 2
						},
						{
							heading: 'V<sub>D<sub>(max)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'VdMax',
							minBoundary: 2.5,
							maxBoundary: 30,
							defaultValue: 15
						},
						{
							heading: 'V<sub>D<sub>(increment)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'VdStep',
							minBoundary: 1,
							maxBoundary: 5,
							defaultValue: 2
						},
						{
							heading: 't<sub>ambient<sub>',
							unit: UNITS_SIGN.CELSIUS,
							netlistUnit: '',
							mappingName: 'Tset',
							minBoundary: -40,
							maxBoundary: 150,
							defaultValue: 25,
							displayInput: true
						}
					]
				},
				{
					heading: 'Temp Sweep',
					showRawData: false,
					inputHeading: 'Input parameters',
					showInputParams: false,

					inputParameters: [
						{
							heading: 'V<sub>GS<sub>(max)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'VgsMax',
							minBoundary: 3,
							maxBoundary: 20,
							defaultValue: 15
						},
						{
							heading: 'V<sub>GS<sub>(min)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'VgsMin',
							minBoundary: 3,
							maxBoundary: 18,
							defaultValue: 6
						},
						{
							heading: 'V<sub>GS<sub>(step)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'VgsStep',
							minBoundary: 0.5,
							maxBoundary: 10,
							defaultValue: 1
						},
						{
							heading: 'V<sub>DS</sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'Vdrain',
							minBoundary: 1,
							maxBoundary: 30,
							defaultValue: 20,
							displayInput: true
						},
						{
							heading: 't<sub>MAX</sub>',
							unit: UNITS_SIGN.CELSIUS,
							netlistUnit: '',
							mappingName: 'tMax',
							minBoundary: -50,
							maxBoundary: 180,
							defaultValue: 175
						},
						{
							heading: 't<sub>MIN</sub>',
							unit: UNITS_SIGN.CELSIUS,
							netlistUnit: '',
							mappingName: 'tMin',
							minBoundary: -55,
							maxBoundary: 150,
							defaultValue: -50
						},
						{
							heading: 't<sub>STEP</sub>',
							unit: UNITS_SIGN.CELSIUS,
							netlistUnit: '',
							mappingName: 'tStep',
							minBoundary: 5,
							maxBoundary: 50,
							defaultValue: 25
						}
					],
					netlist: {
						heading: 'Netlist',
						netlistPath: this.netlistTempSweep,
						displayNetlist: false
					},
					schematic: {
						heading: 'Application schematic',
						schematicPath: this.SCHEMATICTempSweep
					},
					charts: [
						{
							id: 'RdsONVsTemp',
							mainHeading:
								'R[baseline-shift: sub; font-size: 11px;]dsON[/] = f (t,V[baseline-shift: sub;font-size: 11px;]GS[/])',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.DC,
							visible: true,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'temp',
									unit: UNITS_SIGN.CELSIUS,
									columnNumber: TEMP_SWEEP_CHART_COLUMN_MAPPING.TEMP
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'R[baseline-shift: sub; font-size: 11px;]dsON[/]',
									unit: UNITS_SIGN.OHM,
									columnNumber: TEMP_SWEEP_CHART_COLUMN_MAPPING.R_DSON
								}
							],
							series: {
								heading: 'V[baseline-shift: sub;font-size: 11px;]GS[/]',
								unit: UNITS_SIGN.VOLT,
								columnNumber: TEMP_SWEEP_CHART_COLUMN_MAPPING.V_GS
							}
						},
						{
							id: 'RdsONVsVgs',
							mainHeading:
								'R[baseline-shift: sub; font-size: 11px;]dsON[/] = f (V[baseline-shift: sub;font-size: 11px;]GS[/],t)',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.DC,
							visible: true,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'V[baseline-shift: sub;font-size: 11px;]GS[/]',
									unit: UNITS_SIGN.VOLT,
									columnNumber: TEMP_SWEEP_CHART_COLUMN_MAPPING.V_GS
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'R[baseline-shift: sub; font-size: 11px;]dsON[/]',
									unit: UNITS_SIGN.OHM,
									columnNumber: TEMP_SWEEP_CHART_COLUMN_MAPPING.R_DSON
								}
							],
							series: {
								heading: 'Temperature',
								unit: UNITS_SIGN.CELSIUS,
								columnNumber: TEMP_SWEEP_CHART_COLUMN_MAPPING.TEMP
							}
						},
						{
							id: 'IdsVsTemp',
							mainHeading:
								'I[baseline-shift: sub; font-size: 11px;]DS[/] = f (t,V[baseline-shift: sub;font-size: 11px;]GS[/])',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.DC,
							visible: true,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'temp',
									unit: UNITS_SIGN.CELSIUS,
									columnNumber: TEMP_SWEEP_CHART_COLUMN_MAPPING.TEMP
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'I[baseline-shift: sub; font-size: 11px;]DS[/]',
									unit: UNITS_SIGN.AMPER,
									columnNumber: TEMP_SWEEP_CHART_COLUMN_MAPPING.I_DRAIN,
									clampMaxRating: {
										mappingName: SINGLE_MOSFET.I_D_MAX
									}
								}
							],
							series: {
								heading: 'V[baseline-shift: sub;font-size: 11px;]GS[/]',
								unit: UNITS_SIGN.VOLT,
								columnNumber: TEMP_SWEEP_CHART_COLUMN_MAPPING.V_GS
							}
						},
						{
							id: 'IdsVsVgs',
							mainHeading:
								'I[baseline-shift: sub; font-size: 11px;]DS[/] = f (V[baseline-shift: sub;font-size: 11px;]GS[/],t)',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.DC,
							visible: true,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'V[baseline-shift: sub;font-size: 11px;]GS[/]',
									unit: UNITS_SIGN.VOLT,
									columnNumber: TEMP_SWEEP_CHART_COLUMN_MAPPING.V_GS
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'I[baseline-shift: sub; font-size: 11px;]DS[/]',
									unit: UNITS_SIGN.AMPER,
									columnNumber: TEMP_SWEEP_CHART_COLUMN_MAPPING.I_DRAIN,
									clampMaxRating: {
										mappingName: SINGLE_MOSFET.I_D_MAX
									}
								}
							],
							series: {
								heading: 'Temperature',
								unit: UNITS_SIGN.CELSIUS,
								columnNumber: TEMP_SWEEP_CHART_COLUMN_MAPPING.TEMP
							}
						}
					]
				}
			]
		};

		return super.gainDefinition(customizations);
	}
}
